import { Trans, useTranslation } from 'react-i18next'

import { AlertDropDown, Button, Divider, Text } from '@reveni-io/reveni-ui'

import { availableGroupActions } from '@/hooks/useReturnGroup/constants'

import * as Styles from './styles'

const ReturnGroupOut = ({ returnGroup, onLeaveReturnGroup, availableGroupAction }) => {
  const { t, i18n } = useTranslation()

  if (!returnGroup || availableGroupAction !== availableGroupActions.out) return null

  const getFormattedOrderNames = () => {
    const listFormat = new Intl.ListFormat(i18n.language, { style: 'long', type: 'conjunction' })
    return listFormat.format(returnGroup.order_names)
  }

  return (
    <>
      <Divider />
      <Styles.Container>
        <AlertDropDown options={{ withoutDropDown: true }} title={t('Estás combinando devoluciones')}>
          <Styles.InfoContainer>
            <Text type="bodySRegular">
              <Trans i18nKey="returnGroupOutput" values={{ orderNames: getFormattedOrderNames() }}>
                Por favor, devuelve los productos seleccionados junto con tu devolución del pedido{' '}
                <strong>
                  {getFormattedOrderNames()}, en una sola caja, utilizando la misma etiqueta de devolución.
                </strong>
              </Trans>
            </Text>
            <Styles.ActionContainer>
              <Text type="bodySRegular">{t('¿No cabe todo en una sola caja? Solicita un envío adicional')}</Text>
              <Button onClick={onLeaveReturnGroup}>{t('Necesito una etiqueta de devolución adicional')}</Button>
              <Text type="bodyXSRegular">
                {t('Hacer una devolución combinada te ahorra el coste de una etiqueta de devolución para este pedido.')}
              </Text>
            </Styles.ActionContainer>
          </Styles.InfoContainer>
        </AlertDropDown>
      </Styles.Container>
    </>
  )
}

export default ReturnGroupOut
